module.exports = __webpack_public_path__ + "static/fonts/Mont-ExtraLight.62deef7.eot";